import * as Actions from './actions';

export default {
  namespaced: true,
  state: {
    labels: [],
  },
  getters: {
    getLabels: state => {
      return state.labels;
    },
  },
  mutations: {
    setLabels: (state, labels) => {
      state.labels = labels;
    },
  },
  actions: {
    ...Actions,
  },
};
